<template>
	<div style="position: relative">
		<div style="display: flex; flex-direction: column; gap: 10px">
			<div style="display: flex; align-items: center; gap: 12px">
				<div>
					<button
						class="panel-close-button"
						@click="$emit('closePanel')"
						:title="t('panels.modePanel.minimizeTooltip')"
					>
						<svg-icon type="mdi" :path="mdiChevronLeft"></svg-icon>
					</button>
				</div>
				<div>
					<h4>{{ getEditorModeText(store.editorMode) }}</h4>
				</div>
			</div>

			<div v-if="store.editorMode == EditorMode.FeatureMode">
				<FeatureModeControls />
			</div>
			<div v-else-if="store.editorMode == EditorMode.MeasuringMode">
				<MeasuringModeControls />
			</div>
			<div v-else-if="store.editorMode == EditorMode.RollDirectionMode">
				<RollDirectionModeControls />
			</div>
			<div v-else-if="store.editorMode == EditorMode.WeldMode">
				<WeldModeControls />
			</div>
			<div v-else>
				<p>{{ $t("panels.modePanel.noModeSelected") }}</p>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useMainStore } from "@/store/mainStore";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiChevronLeft } from "@mdi/js";
import { EditorMode, getEditorModeText } from "@/model/Enums";
import FeatureModeControls from "./FeatureModeControls.vue";
import MeasuringModeControls from "./MeasuringModeControls.vue";
import RollDirectionModeControls from "./RollDirectionModeControls.vue";
import WeldModeControls from "./WeldModeControls.vue";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["closePanel"]);

const { t } = useI18n();
const store = useMainStore();
</script>
